import type { GuideConfig } from './types';

export const suitGuide: GuideConfig = {
  categoryKey: 'suit',
  title: '신랑님께 꼭 맞는 예복을 찾아드릴게요',
  subtitle: '6가지 질문 · 평균 90초\n현직 플래너의 매칭 기준을 그대로 담았습니다',
  plannerIntro: '플래너 기준 기반',
  questionCount: 6,
  estimatedTime: '약 90초',

  questions: [
    {
      id: 'q1',
      category: '예복 활용도',
      questionText: '신랑님은 평소 정장을 얼마나 자주 입으세요?',
      helperText: '결혼식 이후 예복의 활용도가 달라지는 핵심 질문이에요.',
      selectionType: 'single',
      options: [
        { id: 'q1-rarely', label: '거의 안 입어요', description: '결혼식 이후에는 정장을 입을 일이 거의 없어요', resultType: 'readyMade', reaction: '그러시군요. 결혼식이 특별한 날이라면, 굳이 비싼 맞춤보다 좋은 기성복이 만족도가 더 높으실 수 있어요.' },
        { id: 'q1-events-only', label: '가끔 경조사 때만', description: '경조사나 중요한 날에만 입어요', resultType: 'semiBespoke', reaction: '경조사용 맞춤이라면 합리적인 가격대의 반수제(MTM)가 가장 인기 있어요.' },
        { id: 'q1-business-often', label: '비즈니스 자리에서 자주', description: '업무나 비즈니스 미팅에서 자주 입어요', resultType: 'bespoke', reaction: '오, 정장에 익숙하시면 맞춤이 정답이에요. 핏과 원단을 제대로 고를 줄 아실 거예요.' },
        { id: 'q1-daily', label: '데일리예요', description: '평소에도 정장을 거의 매일 입어요', resultType: 'classic', reaction: '취향이 확실하신 분이네요. 비스포크 라인을 봐드릴게요.' },
      ],
      tipText: '거의 안 입는 분은 기성복(40~60만원대)으로도 충분하고, 자주 입는 분은 반수제 맞춤(80~150만원대)이 만족도가 가장 높아요.',
    },
    {
      id: 'q2',
      category: '핏 보정',
      questionText: '신랑님 체형은 어떠세요? 기성복이 잘 맞는 편이세요?',
      helperText: '체형 보정 난이도에 따라 적합한 테일러가 달라져요.',
      selectionType: 'single',
      options: [
        { id: 'q2-standard', label: '표준 체형, 기성복도 잘 맞아요', description: '기성복을 입어도 큰 수선 없이 잘 맞아요', resultType: 'readyMade', reaction: '표준 체형이시면 선택지가 많아요. 정찰제 운영하는 곳들이 가성비가 좋아요.' },
        { id: 'q2-minor-alteration', label: '한두 군데 수선이 필요해요', description: '소매, 허리 등 일부만 손보면 괜찮아요', resultType: 'semiBespoke', reaction: '그 정도 수선은 어디서든 깔끔하게 가능해요.' },
        { id: 'q2-many-adjustments', label: '여러 부분 보정이 필수예요', description: '어깨, 허리, 팔 길이 등 보정 포인트가 많아요', resultType: 'bespoke', reaction: "그럼 '무한 수정'이 가능한 맞춤 테일러가 필수예요. 가봉 2~3차까지 진행하는 곳으로 좁혀드릴게요." },
        { id: 'q2-not-sure', label: '잘 모르겠어요', description: '체형 보정이 필요한지 아직 모르겠어요', resultType: 'balanced', reaction: '괜찮아요. 상담 첫날 채촌(치수 측정) 후에 테일러 의견을 들으셔도 늦지 않아요.' },
      ],
      tipText: '체형 보정이 필요할수록 가봉 횟수에 제한이 없는 맞춤집을 선택하는 게 가장 중요해요. 단순히 가격보다 이게 만족도를 좌우합니다.',
    },
    {
      id: 'q3',
      category: '원단 취향',
      questionText: '원단 취향, 어느 핏을 좋아하세요?',
      helperText: '원단 산지에 따라 핏감과 가격대가 크게 달라져요.',
      selectionType: 'single',
      options: [
        { id: 'q3-korean', label: '활동적이고 구김 없는 핏', description: '국내 원단처럼 관리가 편한 방향', resultType: 'readyMade', reaction: '스마트한 선택이에요. 국내 원단도 패턴(테일러 실력)이 좋으면 충분히 만족스러워요.' },
        { id: 'q3-italian', label: '부드럽게 흘러내리는 핏', description: '이태리 원단의 유려한 실루엣', resultType: 'semiBespoke', reaction: '유럽 원단 좋아하시는군요. 이태리 원단은 핏이 정말 유려해요.' },
        { id: 'q3-british', label: '묵직하고 클래식한 핏', description: '영국 원단의 탄탄하고 정통적인 느낌', resultType: 'classic', reaction: '정통 수트를 좋아하시네요. 영국 원단 다루는 곳은 많지 않아서 신중하게 골라드릴게요.' },
        { id: 'q3-not-sure', label: '잘 모르겠어요, 상담 때 볼게요', description: '원단 샘플과 완성 수트를 보고 결정하고 싶어요', resultType: 'balanced', reaction: '현명한 결정이에요. 조각 샘플과 완성 수트 핏이 다르거든요.' },
      ],
      tipText: '수입 원단(이태리·영국)은 보통 100만원 이상부터예요. 국내 원단도 패턴이 좋으면 충분히 만족스러우니, 핏은 원단보다 테일러 실력에 더 좌우됩니다.',
    },
    {
      id: 'q4',
      category: '가족 품목',
      questionText: '혹시 가족 품목도 함께 진행하실 계획이 있으세요?',
      helperText: '묶음 진행 시 큰 폭의 할인이 있는 업체가 있어요. 복수 선택할 수 있어요.',
      selectionType: 'multi',
      options: [
        { id: 'q4-fathers-suit', label: '양가 아버님 정장', description: '아버님 정장도 함께 알아보고 있어요', resultType: 'semiBespoke', reaction: '묶음 진행 정보 감사해요. 이 부분이 추천 결과를 크게 좌우해요.' },
        { id: 'q4-mothers-hanbok', label: '양가 어머님 한복', description: '어머님 한복도 함께 진행할 수 있어요', resultType: 'semiBespoke', reaction: '묶음 진행 정보 감사해요. 이 부분이 추천 결과를 크게 좌우해요.' },
        { id: 'q4-bride-hanbok', label: '신부 한복', description: '신부 한복도 함께 알아보고 있어요', resultType: 'semiBespoke', reaction: '묶음 진행 정보 감사해요. 이 부분이 추천 결과를 크게 좌우해요.' },
        { id: 'q4-groomsmen', label: '형제·들러리 정장', description: '형제나 들러리 정장도 필요해요', resultType: 'semiBespoke', reaction: '묶음 진행 정보 감사해요. 이 부분이 추천 결과를 크게 좌우해요.' },
        { id: 'q4-groom-only', label: '신랑 예복만 진행해요', description: '신랑 예복 1벌만 준비할 예정이에요', resultType: 'balanced', exclusive: true, reaction: '묶음 진행 정보 감사해요. 이 부분이 추천 결과를 크게 좌우해요.' },
      ],
      tipText: '같은 대표가 운영하는 한복샵·예복샵 묶음 진행 시 인당 단가가 30~40% 낮아지는 경우도 있어요. 다만 묶음이 정말 이득인지는 개별 견적과 꼭 비교해보세요.',
    },
    {
      id: 'q5',
      category: '방문 동선',
      questionText: '예식·거주지 기준으로 어디가 가장 편하세요?',
      helperText: '예복은 평균 3~4회 방문이 필요한 카테고리예요.',
      selectionType: 'single',
      options: [
        { id: 'q5-gangnam', label: '서울 강남권', description: '강남, 청담, 논현 동선이 편해요', resultType: 'balanced', reaction: '강남권이면 선택지가 정말 많아요.' },
        { id: 'q5-seoul-other', label: '서울 그 외', description: '종로·홍대·성수 등 서울권이 편해요', resultType: 'balanced', reaction: '서울이면 동선 부담 없이 진행하실 수 있어요.' },
        { id: 'q5-gyeonggi-incheon', label: '경기 · 인천', description: '수도권 지점이나 분산 방문이 편해요', resultType: 'balanced', reaction: '그러시면 강남 본점 + 가봉은 지점으로 분산 가능한 브랜드를 추천해드릴게요.' },
        { id: 'q5-local', label: '그 외 지방', description: '전국 지점망이 있는 곳이 편해요', resultType: 'balanced', reaction: '지방이시면 전국 지점망 있는 브랜드가 가장 편하실 거예요.' },
      ],
      tipText: '예복은 상담 → 1차 가봉 → 2차 가봉 → 수령까지 평균 3~4회 방문이에요.',
    },
    {
      id: 'q6',
      category: '예산 기준',
      questionText: '예복 예산은 어느 정도 잡고 계세요?',
      helperText: '신랑 예복 1벌 기준이에요. 솔직하게 답해주세요 :)',
      selectionType: 'single',
      options: [
        { id: 'q6-under-500k', label: '~ 50만원', description: '기성복 위주로 보고 있어요', resultType: 'readyMade', reaction: '합리적인 예산으로도 충분히 멋진 예복을 찾을 수 있어요. 가성비 좋은 기성복 라인을 추천드려요.' },
        { id: 'q6-500k-1m', label: '50 ~ 100만원', description: '합리적인 맞춤을 원해요', resultType: 'semiBespoke', reaction: '반수제 맞춤을 경험하기에 딱 좋은 예산대예요. 원단 선택 폭도 꽤 넓어요.' },
        { id: 'q6-1m-2m', label: '100 ~ 200만원', description: '수입 원단까지 보고 있어요', resultType: 'bespoke', reaction: '풀 비스포크로 내 몸에 딱 맞는 예복을 만들 수 있는 예산이에요. 원단부터 디테일까지 원하는 대로 고를 수 있어요.' },
        { id: 'q6-over-2m', label: '200만원 이상', description: '비스포크까지 고려하고 있어요', resultType: 'classic', reaction: '최상급 원단과 장인의 핸드메이드로 평생 간직할 예복을 만드실 수 있어요.' },
        { id: 'q6-not-decided', label: '아직 정하지 못했어요', description: '상담하면서 예산을 잡고 싶어요', resultType: 'balanced', reaction: '괜찮아요. 예산이 정해지지 않았을수록 견적 범위와 포함 항목을 먼저 비교해보는 게 좋아요.' },
      ],
      tipText: '견적 받을 때 부가세 별도/포함 여부를 꼭 확인하세요. "100만원에 맞춰드린다"에 부가세·부속(셔츠·구두) 별도 붙으면 실 결제는 130만원 이상 되기도 해요.',
    },
  ],

  results: [
    {
      key: 'readyMade',
      displayName: '실속 기성복형',
      summary: '합리적인 가격에 훌륭한 핏을 뽑을 수 있는 타입이에요. 표준 체형에 가깝고, 결혼식 당일 예복의 역할에 충실한 선택을 원하는 분께 적합해요.',
      plannerInterpretation: '기성복도 브랜드와 라인에 따라 퀄리티 차이가 꽤 커요. 피팅 후 기본 수선(소매·밑단)만 해도 사진에서 완성도가 확 달라져요. 신랑님 체형에 잘 맞는 브랜드를 찾는 게 핵심이에요.',
      recommendDirection: '국내외 기성복 브랜드 중에서도 예복 특화 라인을 보유한 업체를 먼저 비교해보세요. 렌탈보다 구매가 가성비가 좋은 경우도 많아요.',
      vendorIds: ['fortungarment', 'atelier', 'billionstailor'],
      keywords: ['합리적인 가격', '바로 구매', '기본 핏'],
      styleProfile: [
        { label: '활용도', value: 25 },
        { label: '예산 효율성', value: 90 },
        { label: '체형 보정 중요도', value: 20 },
        { label: '클래식 선호', value: 35 },
        { label: '원단 관심도', value: 20 },
      ],
      recommendedCombo: '기성복 구매 + 기본 수선(소매·밑단) 조합',
      situationalGuides: [
        {
          title: '시간이 촉박할 때',
          description: '결혼식이 2~3주 남았다면 기성복 매장에서 바로 픽업 가능한 라인을 확인하세요. 당일 피팅 후 수선 맡기면 2~3일 안에 완성돼요.',
        },
        {
          title: '체형이 표준에 가까울 때',
          description: '별도 수선 없이도 충분한 핏을 뽑을 수 있어요. 브랜드별로 같은 사이즈도 실루엣이 다르니 2~3곳 정도 비교 피팅을 추천드려요.',
        },
        {
          title: '예산을 아끼고 싶을 때',
          description: '렌탈보다 구매가 오히려 가성비가 좋은 경우가 많아요. 결혼식 후 중고 판매까지 고려하면 실비용은 더 낮아질 수 있어요.',
        },
      ],
    },
    {
      key: 'semiBespoke',
      displayName: '반수제 밸런스형',
      summary: '정장을 매일 입지는 않지만, 핏과 완성도는 중요하게 보는 타입이에요. 합리적인 가격대의 반수제 맞춤 업체부터 비교해보세요.',
      plannerInterpretation: '반수제는 기성 패턴을 체형에 맞게 수정하는 방식이라, 기성복보다 핏이 훨씬 좋고 풀 비스포크보다 가격 부담이 적어요. 가장 많은 신랑님이 선택하는 방식이에요.',
      recommendDirection: '반수제 맞춤 업체 중에서도 원단 라이브러리가 다양하고 수선 피팅 횟수가 충분한 곳을 골라보세요. 최소 2회 이상 피팅이 가능한 업체가 좋아요.',
      vendorIds: ['billionstailor', 'fortungarment', 'atelier'],
      keywords: ['핏과 가격의 균형', '부분 맞춤', '합리적 투자'],
      styleProfile: [
        { label: '활용도', value: 55 },
        { label: '예산 효율성', value: 70 },
        { label: '체형 보정 중요도', value: 55 },
        { label: '클래식 선호', value: 50 },
        { label: '원단 관심도', value: 50 },
      ],
      recommendedCombo: '기본 수입 원단 + 반수제 맞춤(MTM) + 2회 피팅 조합',
      situationalGuides: [
        {
          title: '핏은 신경 쓰이지만 풀 비스포크는 부담될 때',
          description: '반수제는 체형의 주요 포인트(어깨·허리·소매)만 보정해도 완성도가 크게 올라가요. 비용 대비 만족도가 가장 높은 방식이에요.',
        },
        {
          title: '원단도 어느 정도 신경 쓰고 싶을 때',
          description: '반수제 업체도 이탈리아·영국 기본 라인 원단은 대부분 보유하고 있어요. 원단 샘플북을 꼭 직접 보고 결정하세요.',
        },
        {
          title: '결혼식 후에도 가끔 입을 예정이라면',
          description: '기본 핏만 잘 잡혀도 일상에서도 충분히 입을 수 있어요. 클래식한 네이비·차콜 컬러로 선택하면 활용도가 더 높아져요.',
        },
      ],
    },
    {
      key: 'bespoke',
      displayName: '핏 완성 맞춤형',
      summary: '예복에 진심인 타입이에요. 1:1 패턴부터 원단, 디테일까지 내 몸과 취향에 완벽하게 맞추는 풀 비스포크를 추천드려요.',
      plannerInterpretation: '풀 비스포크는 내 체형만을 위한 패턴을 새로 제작해요. 어깨 기울기, 팔 길이 차이, 체형 비대칭까지 모두 반영되니까 기성복과는 핏 자체가 다릅니다. 원단 선택부터 라펠 모양, 단추까지 전부 내 취향대로!',
      recommendDirection: '풀 비스포크 전문 테일러샵 중에서 포트폴리오가 풍부하고, 원하시는 스타일과 비슷한 작업물이 많은 곳을 비교해보세요. 첫 상담 때 원하시는 핏 이미지를 가져가시는 걸 추천드려요.',
      vendorIds: ['billionstailor', 'heritztailor', 'fortungarment'],
      keywords: ['완벽한 핏', '1:1 패턴', '프리미엄 원단'],
      styleProfile: [
        { label: '활용도', value: 75 },
        { label: '예산 효율성', value: 40 },
        { label: '체형 보정 중요도', value: 85 },
        { label: '클래식 선호', value: 65 },
        { label: '원단 관심도', value: 78 },
      ],
      recommendedCombo: '프리미엄 원단 + 풀 비스포크 + 3회 피팅 + 커스텀 디테일',
      situationalGuides: [
        {
          title: '체형이 비대칭이거나 표준에서 벗어날 때',
          description: '기성복은 아무리 수선해도 한계가 있어요. 풀 비스포크는 어깨 높낮이, 팔 길이 차이까지 패턴에 반영하니까 착용감이 완전히 달라져요.',
        },
        {
          title: '결혼식 후에도 꾸준히 입을 예정이라면',
          description: '좋은 원단과 완벽한 핏의 예복은 5년, 10년 지나도 멋있어요. 오히려 매년 입을수록 가성비가 올라가는 투자예요.',
        },
        {
          title: '디테일까지 내 취향을 반영하고 싶을 때',
          description: '라펠 너비, 단추 재질, 안감 컬러, 포켓 스타일까지 전부 선택할 수 있어요. 세상에 단 하나뿐인 예복이 완성돼요.',
        },
      ],
    },
    {
      key: 'classic',
      displayName: '프리미엄 클래식형',
      summary: '예복을 단순한 의상이 아니라 평생의 투자로 생각하는 타입이에요. 최상급 원단과 장인의 핸드메이드로 완성하는 프리미엄 예복이 어울려요.',
      plannerInterpretation: '프리미엄 비스포크는 원단 선택부터 디테일까지 모든 과정에서 최고를 경험하는 여정이에요. 특히 한정 생산되는 슈퍼 150s 이상 원단은 착용감과 광택이 일반 원단과 차원이 달라요. 예복을 평생의 자산으로 남기고 싶은 분께 추천드려요.',
      recommendDirection: '명품 원단(로로피아나, 스캐발 등)을 취급하고 장인급 테일러가 상주하는 프리미엄 테일러샵을 방문해보세요. 첫 방문 전에 원하는 원단 샘플북을 미리 요청하시면 상담이 훨씬 효율적이에요.',
      vendorIds: ['heritztailor', 'billionstailor', 'fortungarment'],
      keywords: ['최상급 원단', '장인 핸드메이드', '평생 소장'],
      styleProfile: [
        { label: '활용도', value: 60 },
        { label: '예산 효율성', value: 20 },
        { label: '체형 보정 중요도', value: 92 },
        { label: '클래식 선호', value: 95 },
        { label: '원단 관심도', value: 95 },
      ],
      recommendedCombo: '최상급 한정 원단 + 풀 핸드메이드 비스포크 + 장인급 테일러',
      situationalGuides: [
        {
          title: '예복을 평생의 자산으로 남기고 싶을 때',
          description: '슈퍼 150s 이상의 한정 생산 원단은 시간이 지나도 광택과 촉감이 변하지 않아요. 아들에게 물려줄 수 있는 예복을 만드실 수 있어요.',
        },
        {
          title: '원단과 디테일에 타협하고 싶지 않을 때',
          description: '프리미엄 라인은 원단 샘플북의 종류부터 다릅니다. 로로피아나, 스캐발, 제냐 등 명품 원단 중에서 직접 고르는 경험 자체가 특별해요.',
        },
        {
          title: '체형 보정과 착용감이 최우선일 때',
          description: '장인급 테일러는 천 번 이상의 가봉 경험으로 체형의 미세한 차이까지 파악해요. 입었을 때 느껴지는 편안함과 자신감이 완전히 달라요.',
        },
      ],
    },
  ],

  calculateResult(answers: Record<string, string[]>): string {
    const scores: Record<string, number> = {
      readyMade: 0,
      semiBespoke: 0,
      bespoke: 0,
      classic: 0,
    };

    Object.entries(answers).forEach(([questionId, selectedIds]) => {
      const question = suitGuide.questions.find((q) => q.id === questionId);
      if (!question) return;

      selectedIds.forEach((optionId) => {
        const option = question.options.find((o) => o.id === optionId);
        if (!option || !option.resultType) return;

        if (option.resultType === 'balanced') {
          scores.readyMade += 0.25;
          scores.semiBespoke += 0.25;
          scores.bespoke += 0.25;
          scores.classic += 0.25;
        } else if (scores[option.resultType] !== undefined) {
          scores[option.resultType] += 1;
        }
      });
    });

    let maxType = 'semiBespoke';
    let maxScore = 0;
    Object.entries(scores).forEach(([type, score]) => {
      if (score > maxScore) {
        maxScore = score;
        maxType = type;
      }
    });

    return maxType;
  },
  enabled: true,
  headerTitle: '예복 가이드',
  startTitle: '신랑의 격을\n완성하는 한 벌',
  startDescription: '현직 웨딩 플래너 12인이 검증한\n예복 의사결정 기준',
  startCtaText: '예복 기준 찾기',
  hubMainCopy: '신랑의 격을 완성하는 한 벌',
  hubDescription: '현직 웨딩 플래너 12인이 검증한 예복 의사결정 기준으로\n나에게 맞는 예복 스타일을 찾아보세요.',
  hubTags: ['기성복', '반수제', '비스포크', '클래식'],
};
